export default {
  data () {
    let comfirmPass = (rule, value, callback) => {
      if (value !== this.localUser.password) {
        callback(new Error('Nhập lại mật khẩu không đúng'))
      } else {
        callback()
      }
    }
    return {
      submitting: false,
      localUser: {
        shop_name: '',
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        shop_name: [
          {required: true, message: 'Bạn chưa nhập tên user', trigger: 'change'},
          {min: 5, max: 255, message: 'Tên user phải trong khoảng 5 đến 255 ký tự', trigger: 'change'}
        ],
        name: [
          {required: true, message: 'Bạn chưa nhập tên user', trigger: 'change'},
          {min: 2, max: 255, message: 'Tên user phải trong khoảng 2 đến 255 ký tự', trigger: 'change'}
        ],
        phone: [
          {required: true, message: 'Bạn chưa nhập số điện thoại', trigger: 'change'},
          {min: 9, max: 12, message: 'Số điện thoại phải trong khoảng 9 đến 12 ký tự', trigger: 'change'}
        ],
        email: [
          {required: true, message: 'Bạn chưa nhập email', trigger: 'change'},
          {type: 'email', message: 'Email không đúng định dạng', trigger: 'change'}
        ],
        password: [
          {
            required: true,
            message: 'Mật khẩu không được để trống',
            trigger: 'change'
          },
          {
            min: 6,
            max: 32,
            message: 'Mật khẩu phải trong khoảng 6 đến 32 ký tự',
            trigger: 'change'
          }
        ],
        password_confirmation: [
          {
            required: true,
            message: 'Nhập lại mật khẩu không được để trống',
            trigger: 'change'
          },
          {
            validator: comfirmPass,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    newUser () {
      this.localUser = {
        shop_name: '',
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  mounted () {
    this.newUser()
  },
  watch: {
    localUser: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user/mixins/index.js